import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { NotificationModalComponent } from './notification-modal.component';

@NgModule({
    declarations: [
        NotificationModalComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
        ReactiveFormsModule,
    ],
    exports: [
        NotificationModalComponent,
    ]
})
export class NotificationModalModule {
}
